export default function TruncatedText({ text, maxLength, classes = '' }) {
  const truncatedText =
    text?.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  
  return (
    <span 
      className={`${classes}`}>
      {truncatedText}
    </span>
  );
}